import { FormikValues } from 'formik';
import { useMemo, useCallback } from 'react';
import {
  Client,
  useAlert,
  useNavigate,
  handleMutation,
} from '@gv/triage-components';

import { useHospitalParams } from 'hooks';
import { useOptionalHospitalData } from 'hooks';
import { useCreateMutation } from 'store/api/clients';

import { Form } from './form';
import { ClientFormPage } from './types';
import { getPayload, createInitialValues } from './config';

const CreateGlobal = ({
  backTo,
  onFinish,
  hospitalId,
  initialValues,
}: ClientFormPage) => {
  const navigate = useNavigate();
  const { showErrorAlert } = useAlert();
  const onSuccess = useCallback(() => navigate(backTo ?? -1), [backTo]);
  const [create, mutation] = useCreateMutation();
  handleMutation({ ...mutation, onSuccess });

  const onSubmit = useCallback(
    async (values: FormikValues): Promise<void> => {
      const response: any = await create(getPayload(values, hospitalId!));
      if (
        response?.data?.message_alert &&
        response?.data?.message_alert !== ''
      ) {
        showErrorAlert(response?.data?.message_alert);
      }
      if (onFinish) {
        const client = (response as any)?.data;
        if (client) {
          onFinish(client as Client);
        }
      }
    },
    [create, onFinish]
  );

  const intiail = useMemo(
    () => createInitialValues(initialValues),
    [initialValues]
  );
  const { hospital } = useOptionalHospitalData(hospitalId);
  if (intiail?.phones && Array.isArray(intiail.phones)) {
    intiail.phones = intiail.phones.map((num) =>
      num === hospital?.phone ? '' : num
    );
  }
  return (
    <Form onSubmit={onSubmit} hospitalId={hospitalId} initialValues={intiail} />
  );
};

const Create = () => {
  const { id } = useHospitalParams();
  return <CreateGlobal hospitalId={id} />;
};

export { Create, CreateGlobal };
